import * as zlib from 'zlib';

function compress(input: string): Promise<{ erro: boolean; dados: Buffer }> {
  return new Promise((resolve, reject) => {
    zlib.gzip(input, (error, result) => {
      if (error) {
        return reject(error);
      }
      resolve({
        erro: false,
        dados: result,
      });
    });
  });
}

function decompress(input: Buffer): Promise<string> {
  return new Promise((resolve, reject) => {
    zlib.gunzip(input, (error, result) => {
      if (error) {
        return reject(error);
      }
      resolve(result.toString());
    });
  });
}

export { compress, decompress };
